import { frontendURL } from '../../../helper/URLHelper';
import KnowledgeImprovement from './Index.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/knowledge_improvement'),
      name: 'knowledge_improvement',
      component: KnowledgeImprovement,
      meta: {
        permissions: ['administrator', 'restricted'],
      },
      // Router guard to check subscription using cached data
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    }
  ],
};
